import React from 'react';
import './FreshPotatoes.css';

// tippy
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional
import { followCursor } from 'tippy.js';

import Card from '../../ui/Card';

import FreshPotatoesCover from './cover.png';
import LFP2 from './img/lfp-issue-2.jpg';
import LFP from './img/lfp.jpg';
import MovieInfoPage from './img/movie-info-1500.png';
import PotatoFarmPage from './img/potato-farm-1500.png';
import UserProfilePage from './img/user-profile-1500.png';

function FreshPotatoes({ ...props }) {
  return (
    <div className="mb-20 mx-3">
      <div className="sidebar"></div>
      <div className="main-container">
        <h1>Fresh Potatoes</h1>
        <p className="text-center">An Efficient Movie Searching Solution</p>
        <Card
          title="Fresh Potatoes"
          description="Full-Stack Development"
          coverImage={FreshPotatoesCover}
          coverImagePosition="top"
          className="card-modify no-cover"
        />
        <div className="overview mb-20">
          <div>
            <h2>My role</h2>
            <p className="mb-5">Front-End Lead - UI/UX Design, User Flows, Client-side Development</p>
            <h2>Time</h2>
            <p className="mb-5">Jan 2021</p>
            <h2>Duration</h2>
            <p className="mb-5">three months</p>
          </div>
          <div className="overview-details">
            <h2>Overview</h2>
            <p>
              Developed by a team of six students to provide a simplified and more efficient movie searching process for
              any users that watches movies and TV shows at any age range. Fresh Potato aims to solve the problem by
              implementing more defined and detailed recommendation options as well as filtering the movies and shows
              based on the streaming platforms the users are on with the help of Django web framework and TMDB (The
              Movie Database) API.
            </p>
          </div>
        </div>
        <div className="tech mb-20">
          <h2>Tech</h2>
          <hr />
          <div className="flex flex-row space-x-4">
            <h2 className="font-semibold text-2xl text-white items-center flex">Django</h2>
            <Tippy className="custom-tooltip" followCursor={true} plugins={[followCursor]} content="Python">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                height="50"
                width="50"
                aria-label="python"
                role="img"
                fill="#ffffff"
              >
                <path d="M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4 .1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8 .1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3 .1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z" />
              </svg>
            </Tippy>
            {/* html */}
            <Tippy className="custom-tooltip" followCursor={true} plugins={[followCursor]} content="HTML">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                height="50"
                width="50"
                aria-label="html"
                role="img"
                fill="#ffffff"
              >
                <path d="M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z" />
              </svg>
            </Tippy>
            {/* css */}
            <Tippy className="custom-tooltip" followCursor={true} plugins={[followCursor]} content="CSS">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                height="50"
                width="50"
                aria-label="css"
                role="img"
                fill="#ffffff"
              >
                <path d="M376.3 32L0 32 0 408.3c0 19 7.6 37.2 21 50.7s31.7 21 50.7 21l304.6 0c19 0 37.2-7.6 50.7-21s21-31.7 21-50.7l0-304.6c0-19-7.6-37.2-21-50.7s-31.7-21-50.7-21zM332.4 431.4c-7.7-8.5-11.7-20.7-12-36.6l31.3 0c.2 14.1 5.1 21.1 14.8 21.1c4.9 0 8.4-1.6 10.5-4.7c2-3.1 3-8 3-14.8c0-5.4-1.3-9.9-4-13.4c-3.5-4.2-8.1-7.5-13.2-9.5L351.2 368c-10.3-4.9-17.8-10.8-22.5-17.6c-4.5-6.8-6.7-16.3-6.7-28.4c0-13.6 4-24.6 11.8-33.1c8.1-8.5 19.1-12.7 33.2-12.7c13.6 0 24.1 4.2 31.5 12.5c7.5 8.4 11.5 20.3 11.8 35.9l-30.1 0c.2-5.1-.9-10.2-3-14.8c-1.7-3.4-5-5.1-10-5.1c-8.8 0-13.2 5.2-13.2 15.7c0 5.3 1.1 9.4 3.2 12.6c3.1 3.5 7 6.2 11.4 7.8l11.1 4.9c11.5 5.3 19.7 11.7 24.8 19.4c5.1 7.7 7.6 18 7.6 31c0 15.5-4 27.4-12.3 35.7c-8.2 8.3-19.5 12.5-34.1 12.5s-25.6-4.2-33.4-12.7zm-101 0c-7.7-8.5-11.7-20.7-12-36.6l31.3 0c.2 14.1 5.1 21.1 14.8 21.1c4.9 0 8.4-1.6 10.4-4.7c2-3.1 3-8 3-14.8c0-5.4-1.3-9.9-3.9-13.4c-3.5-4.2-8.1-7.5-13.2-9.5L250.2 368c-10.3-4.9-17.8-10.8-22.5-17.6c-4.5-6.8-6.7-16.3-6.7-28.4c0-13.6 4-24.6 11.8-33.1c8.1-8.5 19.1-12.7 33.2-12.7c13.6 0 24.1 4.2 31.4 12.5c7.6 8.4 11.5 20.3 11.9 35.9l-30.1 0c.2-5.1-.9-10.2-3-14.8c-1.7-3.4-5-5.1-10-5.1c-8.8 0-13.2 5.2-13.2 15.7c0 5.3 1.1 9.4 3.2 12.6c3.1 3.5 7 6.2 11.4 7.8l11.1 4.9c11.5 5.3 19.7 11.7 24.8 19.4c5.1 7.7 7.6 18 7.6 31c0 15.5-4.1 27.4-12.3 35.7s-19.5 12.5-34.1 12.5s-25.6-4.2-33.4-12.7zm-105.6 1.1c-8.4-7.7-12.5-19.2-12.5-34.5l0-75.4c0-15.2 4.4-26.7 13.2-34.6c8.9-7.8 20.7-11.8 35.2-11.8c14.1 0 25.2 4 33.4 12c8.3 8 12.5 20 12.5 35.9l0 6-33.1 0 0-5.8c0-6.1-1.3-10.7-4-13.6c-1.1-1.5-2.6-2.7-4.3-3.5s-3.5-1.2-5.4-1.1c-5.4 0-9.2 1.8-11.4 5.6c-2.3 5.2-3.3 10.8-3 16.4l0 65.5c0 13.7 4.8 20.6 14.4 20.8c4.5 0 7.9-1.6 10.2-4.8c2.5-4.1 3.7-8.8 3.5-13.6l0-4.9 33.1 0 0 5.1c0 10.6-2.1 19.5-6.2 26.6c-4 6.9-9.9 12.5-17.1 16c-7.7 3.7-16.1 5.5-24.6 5.3c-14.2 0-25.5-3.9-33.8-11.6z" />
              </svg>
            </Tippy>
          </div>
        </div>
        <div className="process mb-20">
          <h2>Process</h2>
          <hr />
          <p className="mb-7">
            I first established the requirements and user flow of the website, and then began to build out the
            information architecture of the pages with low fidelity prototyping. After the overall design was approved.
            I went on to high fidelity prototypes and began coding/developing the front-end.
          </p>
          <h3 className="mb-3">Requirements & Prototyping</h3>
          <p className="mb-2">1. Aesthetic and minimalist design</p>
          <p className="mb-2">2. User-friendly interface</p>
          <p className="mb-2">3. Flexibility and efficiency of use</p>
          <Card
            title="Survey & User Home Page"
            description="Low Fidelity Prototype"
            coverImage={LFP}
            coverImagePosition="top"
            className="card-modify"
          />
          <Card
            title="Movie Info Page"
            description="Low Fidelity Prototype"
            coverImage={LFP2}
            coverImagePosition="top"
            className="card-modify"
          />
        </div>
        <div className="final mb-20">
          <h2>Final Product</h2>
          <hr />
          <Card
            title="Movie Info Page"
            description="Movie Info from TMDB API"
            coverImage={MovieInfoPage}
            coverImagePosition="top"
            className="card-modify"
          />
          <Card
            title="Movie Info Page"
            description="Recommendation Algorithm Based on User Preferences"
            coverImage={UserProfilePage}
            coverImagePosition="top"
            className="card-modify"
          />
          <Card
            title="Movie Info Page"
            description="Watch Later"
            coverImage={PotatoFarmPage}
            coverImagePosition="top"
            className="card-modify"
          />
        </div>
        <div className="retrospective">
          <h2>Retrospective</h2>
          <hr />
          <p>
            Being the main deliverable of a lower division software engineering course, this project provided me with an
            overview of various techniques used for software development and project management, including design,
            requirements, implementation, testing, and scrum methodology.
          </p>
          <h3 className="mb-2 mt-5">Scrum Methodology</h3>
          <p>
            During the development of this project, we tried to follow the Scrum methodology as best as we can to mimic
            a professional work place. I participated in weekly meetings where we would plan out our work and goals for
            the next week as well as sharing what I've achieved in the previous week with the team. Though there were no
            daily Scrum meetings due to our conflicting school schedule among five members, it set a solid structure for
            my team which enabled us to complete project deliverables quickly and efficiently.
          </p>
          <h3 className="mb-2 mt-5">
            This project also provided me with many other experiences in full-stack development
          </h3>
          <p className="mb-2">
            1. Separation between the application's logic and display with the implementation of Model-View-Controller
            framework
          </p>
          <p className="mb-2">2. Front-end development with specific requirements tailored to our targeted audiences</p>
          <p className="mb-2">3. Utilization of popular modern tools and follow the current industry standards</p>
          <p className="mb-2">
            4. Prioritize user experience with muliple rounds of testing and improving to reduce the run time of
            back-end algorithms and overall loading speed of the application
          </p>
        </div>
      </div>
    </div>
  );
}

export default FreshPotatoes;
